module.exports = __webpack_public_path__ + "media/call-ringtone.181b7fea.ogg";